// ----------------------------------------------------------------------------
// Template: Product
// ----------------------------------------------------------------------------
// 
// ----------------------------------------------------------------------------


// -------------------------------------
// Dependencies
// -------------------------------------

// Scripts
import {load} from '@shopify/theme-sections';
import 'snippets/breadcrumbs/breadcrumbs';
import 'snippets/reviews/reviews';
import 'snippets/cart-confirmation/cart-confirmation';
import 'snippets/_containers/swatches/swatches';
import 'snippets/product-tags/product-tags';
import 'snippets/bold-upsell/bold-upsell';

import 'sections/header/header';
import 'sections/footer/footer';
import 'sections/product/product';
import 'sections/product-recommendations/product-recommendations';

// Styles
import './_product.scss';


// -------------------------------------
// Hooks
// -------------------------------------
document.addEventListener('DOMContentLoaded', () => {
  load('*');
});
